import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";

import Home from "./pages/Home/Home";
import AdminLogin from "./components/AdminLogin/AdminLogin";

import ProtectedAdminRoute from "./routes/ProtectedAdminRoute";
import DashboardLayout from "./components/dashboard/DashboardLayout";
import DashboardHome from "./pages/AdminDashboard/DashboardHome";
import OrdersPage from "./pages/AdminDashboard/Orders/OrdersPage";
import OrdersStatsPage from "./pages/AdminDashboard/Orders/OrdersStatsPage";
import ContentPage from "./pages/AdminDashboard/Content/ContentPage";
import YourOrder from "./components/YourOrder/YourOrder";
import ProductDetails from "./pages/ProductDetails/ProductDetails";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/parfume/:id" element={<ProductDetails />} />
            <Route path="/adminlogin" element={<AdminLogin />} />
            <Route path="/yourorder" element={<YourOrder />} />

            <Route
              path="/admin"
              element={
                <ProtectedAdminRoute>
                  <DashboardLayout />
                </ProtectedAdminRoute>
              }
            >
              <Route index element={<DashboardHome />} />
              <Route path="orders" element={<OrdersPage />} />
              <Route path="stats" element={<OrdersStatsPage />} />
              <Route path="content" element={<ContentPage />} />
            </Route>
          </Routes>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
